import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const Compounds = (props) => {

    const { simpleProduct, setSimpleProduct, productCompounds, setProductCompounds } = props;

    const { api, userData, settingData, categoryData, vatGroupData, selectedCompany, accountData,
        productData, refData, branchData, salableOptions, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    // Add VarientRow
    const handleAddRow = () => {
        setProductCompounds([...productCompounds, { productId: '', quantity: 0 }]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event) => {
        event.preventDefault()
        if (productCompounds.length > 0) {
            const updatedRows = productCompounds.slice(0, -1);
            setProductCompounds(updatedRows);
        } else {
            toast.error('you need at least one variant')
        }
    };


    const handleRowChange = (index, value, field) => {

        const updatedCompounds = [...productCompounds];

        if (field == 'product') {
            updatedCompounds[index].productId = value.id;
            updatedCompounds[index].cost = value.cost;
        } else if (field == 'quantity') {
            updatedCompounds[index].quantity = value;
        }
        updatedCompounds[index].totalCost = updatedCompounds[index].cost * updatedCompounds[index].quantity;
        setProductCompounds(updatedCompounds);

        const productCost = updatedCompounds.reduce( (sum, compound) => sum + (Number(compound.totalCost) || 0), 0);
        setSimpleProduct(prev => ({...prev, cost: productCost}));
    }

    //filter products
    const typeFilteredOptions = salableOptions.filter(option =>
        option.type === "simple" || option.type === "serialized"
    );
    const loadSalableOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? typeFilteredOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
        callback(filteredOptions);
    };


    
    return (

        <div>

            {productCompounds.map((row, index) => (
                <div key={index}>
                    {/* Render the labels only for the first row */}
                    {index === 0 && (
                        <Row className="mb-4">
                            <Col md={6}>
                                <Form.Label>Product</Form.Label>
                            </Col>
                            <Form.Group as={Col}>
                                <Form.Label>quantity</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Cost</Form.Label>
                            </Form.Group>
                        </Row>
                    )}

                    <Row className="mb-2" style={{ marginTop: '-20px' }}>

                        <Col md={6}>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadSalableOptions}
                                defaultOptions={[]}
                                onChange={(e) => handleRowChange(index, e, 'product')}
                                value={salableOptions?.find(option => option.value === productCompounds[index].productId) || []}
                                noOptionsMessage={() => 'type to view'}
                                required
                            />
                        </Col>

                        <Col>
                            <Form.Control type="number" step="any" name="quantity"
                                onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                                value={productCompounds[index].quantity}
                                required />
                        </Col>

                        <Col>
                            <Form.Control type="number" step="any" name="cost"
                                value={productCompounds[index].totalCost}
                                disabled />
                        </Col>



                    </Row>

                    <Row key={index + 100} className="mb-3">

                    </Row>
                </div>
            ))}

            <Form.Group
                as={Col}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />
            </Form.Group>
        </div>

    )
}


export default Compounds;